"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const model_env_scopes_1 = __importDefault(require("../enums/model-env-scopes"));
const model_scopes_1 = __importDefault(require("../enums/model-scopes"));
const server_hooks_events_1 = __importDefault(require("../enums/server-hooks-events"));
const GraphandFieldBoolean_1 = __importDefault(require("../lib/fields/GraphandFieldBoolean"));
const GraphandFieldDate_1 = __importDefault(require("../lib/fields/GraphandFieldDate"));
const GraphandFieldText_1 = __importDefault(require("../lib/fields/GraphandFieldText"));
const GraphandModel_1 = __importDefault(require("../lib/GraphandModel"));
/**
 * @class Sockethook
 * @augments GraphandModel
 * @classdesc Sockethook model. Use {@link GraphandClient#getModel client.getModel("Sockethook")} to use this model
 */
class SockethookHost extends GraphandModel_1.default {
    /**
     * Ping current sockethook
     * @returns {number} - time in ms
     */
    async ping() {
        const { constructor } = Object.getPrototypeOf(this);
        try {
            const { data } = await constructor._client._axios.get(`${constructor.baseUrl}/${this._id}/ping`);
            return data.data;
        }
        catch (e) {
            return false;
        }
    }
    async block() {
        const initial = !!this.blocked;
        const { constructor } = Object.getPrototypeOf(this);
        this.blocked = true;
        try {
            await constructor._client._axios.post(`${constructor.baseUrl}/${this._id}/block`);
        }
        catch (e) {
            this.blocked = initial;
            throw e;
        }
    }
    async unblock() {
        const initial = !!this.blocked;
        const { constructor } = Object.getPrototypeOf(this);
        this.blocked = false;
        try {
            await constructor._client._axios.post(`${constructor.baseUrl}/${this._id}/unblock`);
        }
        catch (e) {
            this.blocked = initial;
            throw e;
        }
    }
}
SockethookHost._customFields = {};
SockethookHost.apiIdentifier = "sockethookhosts";
SockethookHost.baseUrl = "/sockethooks/hosts";
SockethookHost.scope = model_scopes_1.default.SockethookHost;
SockethookHost.envScope = model_env_scopes_1.default.ENV;
SockethookHost.schema = {
    name: new GraphandFieldText_1.default(),
    socket: new GraphandFieldText_1.default(),
    connectedAt: new GraphandFieldDate_1.default(),
    blocked: new GraphandFieldBoolean_1.default(),
};
SockethookHost.Events = server_hooks_events_1.default;
exports.default = SockethookHost;
